/* Vyelle PDP — Tier 1 interactive layer */

(function () {
  'use strict';

  function initPDP() {
    var subList = document.querySelector('.vyelle-sub-mechanics');
    var perSub = document.querySelector('.vyelle-per-serving--sub');
    var perOt  = document.querySelector('.vyelle-per-serving--ot');

    if (!subList && !perSub && !perOt) return;

    /* Determine if a variant input/radio signals a subscription */
    function isSub(el) {
      var name  = (el.name  || '').toLowerCase();
      var val   = (el.value || '').toLowerCase();
      var label = '';
      var lbl   = el.closest('label') || document.querySelector('label[for="' + el.id + '"]');
      if (lbl) label = lbl.textContent.toLowerCase();
      return /subscribe|sub|month/.test(val + ' ' + label);
    }

    function updateUI() {
      /* Try radio inputs for purchase-type selector */
      var radios = document.querySelectorAll(
        'input[name*="purchase_type" i], input[name*="selling_plan" i], input[type="radio"][name*="option" i]'
      );
      var checkedSub = false;
      var foundAny   = false;

      radios.forEach(function (r) {
        if (r.checked) {
          foundAny = true;
          if (isSub(r)) checkedSub = true;
        }
      });

      /* Fallback: look for active/selected class on variant option buttons */
      if (!foundAny) {
        var activeBtns = document.querySelectorAll('[data-option-value].active, [data-option-value][aria-checked="true"], [data-option-value].selected');
        activeBtns.forEach(function (btn) {
          var txt = (btn.dataset.optionValue || btn.textContent || '').toLowerCase();
          if (/subscribe|sub|month/.test(txt)) checkedSub = true;
          foundAny = true;
        });
      }

      /* Default to showing sub view if nothing found (Subscribe & Save is first) */
      if (!foundAny) checkedSub = true;

      if (subList)  subList.style.display  = checkedSub ? 'block' : 'none';
      if (perSub)   perSub.style.display   = checkedSub ? 'block' : 'none';
      if (perOt)    perOt.style.display    = checkedSub ? 'none'  : 'block';
    }

    updateUI();

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (
        t.matches('input[name*="purchase_type" i]') ||
        t.matches('input[name*="selling_plan" i]') ||
        t.matches('input[type="radio"]')
      ) {
        setTimeout(updateUI, 0);
      }
    });

    /* Also catch Horizon's custom variant-change events */
    document.addEventListener('variant:change', function () { setTimeout(updateUI, 0); });
    document.addEventListener('variantChanged',  function () { setTimeout(updateUI, 0); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPDP);
  } else {
    initPDP();
  }
})();
